export class PointerLockFPS {
    constructor(dom, options = {}) {
        var _a;
        this.isLocked = false;
        this.moveForward = false;
        this.moveBackward = false;
        this.moveLeft = false;
        this.moveRight = false;
        this.moveUp = false;
        this.moveDown = false;
        this.lastMouseX = 0;
        this.lastMouseY = 0;
        this.deltaYaw = 0;
        this.deltaPitch = 0;
        this.dom = dom;
        this.shouldIgnoreKeyboard = (_a = options.shouldIgnoreKeyboard) !== null && _a !== void 0 ? _a : null;
    }
    enable() {
        this.dom.tabIndex = 0;
        this.dom.style.touchAction = 'none';
        const onMouseMove = (e) => {
            if (!this.isLocked)
                return;
            this.deltaYaw += -e.movementX * 0.0025;
            this.deltaPitch += -e.movementY * 0.0025;
        };
        const onPointerDown = () => {
            var _a, _b;
            if (!this.isLocked)
                (_b = (_a = this.dom).requestPointerLock) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        const onPointerLockChange = () => {
            this.isLocked = (document.pointerLockElement === this.dom);
        };
        const onKeyDown = (e) => {
            var _a;
            if ((_a = this.shouldIgnoreKeyboard) === null || _a === void 0 ? void 0 : _a.call(this))
                return;
            // UI/chat routing should happen outside before events reach here
            switch (e.code) {
                case 'KeyW':
                    this.moveForward = true;
                    break;
                case 'KeyS':
                    this.moveBackward = true;
                    break;
                case 'KeyA':
                    this.moveLeft = true;
                    break;
                case 'KeyD':
                    this.moveRight = true;
                    break;
                case 'Space':
                    this.moveUp = true;
                    break;
                case 'ShiftLeft':
                    this.moveDown = true;
                    break;
            }
        };
        const onKeyUp = (e) => {
            var _a;
            if ((_a = this.shouldIgnoreKeyboard) === null || _a === void 0 ? void 0 : _a.call(this))
                return;
            switch (e.code) {
                case 'KeyW':
                    this.moveForward = false;
                    break;
                case 'KeyS':
                    this.moveBackward = false;
                    break;
                case 'KeyA':
                    this.moveLeft = false;
                    break;
                case 'KeyD':
                    this.moveRight = false;
                    break;
                case 'Space':
                    this.moveUp = false;
                    break;
                case 'ShiftLeft':
                    this.moveDown = false;
                    break;
            }
        };
        // store handlers on element for easy removal
        this._handlers = { onMouseMove, onPointerDown, onPointerLockChange, onKeyDown, onKeyUp };
        window.addEventListener('mousemove', onMouseMove);
        this.dom.addEventListener('mousedown', onPointerDown);
        document.addEventListener('pointerlockchange', onPointerLockChange);
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('keyup', onKeyUp);
    }
    disable() {
        const h = this._handlers;
        if (!h)
            return;
        window.removeEventListener('mousemove', h.onMouseMove);
        this.dom.removeEventListener('mousedown', h.onPointerDown);
        document.removeEventListener('pointerlockchange', h.onPointerLockChange);
        window.removeEventListener('keydown', h.onKeyDown);
        window.removeEventListener('keyup', h.onKeyUp);
        this._handlers = undefined;
    }
    sample() {
        const forwardBack = (this.moveForward ? 1 : 0) + (this.moveBackward ? -1 : 0);
        const leftRight = (this.moveRight ? 1 : 0) + (this.moveLeft ? -1 : 0);
        const upDown = (this.moveUp ? 1 : 0) + (this.moveDown ? -1 : 0);
        const intent = {
            moveForwardBack: forwardBack,
            moveLeftRight: leftRight,
            moveUpDown: upDown,
            deltaYaw: this.deltaYaw,
            deltaPitch: this.deltaPitch
        };
        // reset deltas each sample
        this.deltaYaw = 0;
        this.deltaPitch = 0;
        return intent;
    }
}
